import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FadeUp, SectionHeading } from "../components/motion";

const FAQS = [
  {
    q: "Are dates and destinations confirmed?",
    a: "Not yet. Our inaugural retreat is in development; cruise dates, ships, destinations, and prices will be announced when confirmed.",
  },
  {
    q: "Can I book or pay now?",
    a: "Registration is not open. Joining the interest list simply shares your preferences—no payment or reservation is involved.",
  },
  {
    q: "Do I need to be writing a book?",
    a: "No. The writing workshops are introductory and optional—no writing experience or publishing goal is required.",
  },
  {
    q: "Are sessions required?",
    a: "Planned sessions are optional. The schedule is gentle, with substantial free time built in.",
  },
  {
    q: "Is this an employment event?",
    a: "Renewal is the central purpose; professional connections are optional.",
  },
  {
    q: "Can a spouse or companion attend?",
    a: "We are gathering interest; arrangements will be announced.",
  },
  {
    q: "Can I attend if I’m not a chaplain?",
    a: "Yes. People exploring chaplaincy are welcome. Attendance does not provide professional certification or guarantee employment.",
  },
  {
    q: "Is continuing education credit available?",
    a: "No credit is currently being advertised or promised.",
  },
];

export default function Faq() {
  return (
    <section id="faq" data-testid="section-faq" className="bg-parchment py-24 sm:py-32">
      <div className="mx-auto max-w-4xl px-5 sm:px-8">
        <SectionHeading eyebrow="Questions" titleLines={["Frequently asked", "questions"]} tone="light-bg" />
        <FadeUp delay={0.2}>
          <Accordion type="single" collapsible className="mt-12 border-t border-navy/12" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={"q" + i} className="border-b border-navy/12" data-testid={"faq-item-" + (i + 1)}>
                <AccordionTrigger className="py-6 text-left font-serif text-xl font-normal text-navy hover:text-gold hover:no-underline sm:text-2xl [&>svg]:text-gold">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-sm leading-relaxed text-navy/70 sm:text-base">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </FadeUp>
      </div>
    </section>
  );
}
